import { AxiosUpdateTuple, usePutAxiosHook } from '../../AxiosPutHook';

export const useUpdateSupportTeam = (clientId: string): AxiosUpdateTuple => {
  const URL = '/api/clients/' + clientId + '/support-team';

  const [callBack, { data, loading, called, error }] = usePutAxiosHook(URL);

  return [callBack, { data, loading, called, error }];
};
